export default Object.freeze({
  KEY_MESSAGE_READ: 'messages-read',
  KEY_MESSAGES_LOADED: 'messages-loaded',
  KEY_IMMEDIATE_MESSAGES: 'immediate-messages',
  KEY_INBOX_MESSAGES: 'inbox-messages',
});
